import toast from "react-hot-toast";
import { ToastOptions } from "../@types";
import AppToast from "../components/ui/Toast";

export const useToast = () => {
  const showToast = {
    success: ({ title, message }: ToastOptions) => {
      toast.custom((t: any) => (
        <AppToast t={t} type="success" title={title} message={message} />
      ));
    },
    error: ({ title, message }: ToastOptions) => {
      toast.custom((t: any) => (
        <AppToast t={t} type="error" title={title} message={message} />
      ));
    },
    warning: ({ title, message }: ToastOptions) => {
      toast.custom((t: any) => (
        <AppToast t={t} type="warning" title={title} message={message} />
      ));
    },
    info: ({ title, message }: ToastOptions) => {
      toast.custom((t: any) => (
        <AppToast t={t} type="info" title={title} message={message} />
      ));
    },
  };

  return showToast;
};
